import * as authTypes from '../mutation-type/auth'
import { SET_PUBLIC_SETTINGS } from '../mutation-types'
import settingsService from '../services/settings'

// state
export const state = {
  // Global, admin-controlled display flags delivered on bootstrap.
  showMsrp: false,
  // Serves the admin-configurable mega menu header instead of the legacy one.
  // Defaults false, so any failure to load the flag keeps the old header.
  megaMenuEnabled: false,
  // Whether the flags above are the server's answer or still the defaults.
  // The boot gate (middleware/check-auth.js) reads this so it fetches once per
  // session instead of on every route change.
  publicSettingsLoaded: false
}

// getters
export const getters = {
  showMsrp: state => state.showMsrp,
  megaMenuEnabled: state => state.megaMenuEnabled,
  publicSettingsLoaded: state => state.publicSettingsLoaded
}

// mutations
export const mutations = {
  [SET_PUBLIC_SETTINGS] (state, settings) {
    state.showMsrp = !!settings.show_msrp
    state.megaMenuEnabled = !!settings.mega_menu_enabled
    state.publicSettingsLoaded = true
  }
}

// actions
export const actions = {
  async updateUser ({ commit }, payload) {
    try {
      const { data } = settingsService.updateProfile(payload)
      commit(authTypes.UPDATE_USER, data)
    } catch (error) {
      console.log('Error: ', error)
    }
  },

  // Load global flags once on app bootstrap.
  async fetchPublicSettings ({ commit }) {
    const { data } = await settingsService.getPublic()
    commit(SET_PUBLIC_SETTINGS, data || {})
    return data
  },

  // Admin: persist global flags, then reflect them locally.
  async updatePublicSettings ({ commit }, payload) {
    const { data } = await settingsService.updatePublic(payload)
    commit(SET_PUBLIC_SETTINGS, data || {})
    return data
  }
}
